const IV_LENGTH = 12;

function base64ToArrayBuffer(base64) {
    const binary = atob(base64);
    const len = binary.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        bytes[i] = binary.charCodeAt(i);
    }
    return bytes.buffer;
}

function arrayBufferToString(buf) {
    const dec = new TextDecoder();
    return dec.decode(new Uint8Array(buf));
}

function stringToArrayBuffer(str) {
    const enc = new TextEncoder();
    return enc.encode(str);
}

async function importAesKey(keyString) {
    const keyBytes = stringToArrayBuffer(keyString);
    // comprobar longitud
    if (keyBytes.byteLength === 16 || keyBytes.byteLength === 24 || keyBytes.byteLength === 32) {
        return crypto.subtle.importKey('raw', keyBytes, 'AES-GCM', false, ['decrypt']);
    } else {
        // derivar por SHA-256 -> 32 bytes
        const hash = await crypto.subtle.digest('SHA-256', keyBytes);
        return crypto.subtle.importKey('raw', hash, 'AES-GCM', false, ['decrypt']);
    }
}

export async function decryptAesGcmBase64(base64Value, keyString) {
    if (!base64Value || typeof base64Value !== 'string') return base64Value;

    let buffer;

    try {
        buffer = base64ToArrayBuffer(base64Value);
    } catch (e) {
        throw new Error('Valor no es base64 válido');
    }

    const bytes = new Uint8Array(buffer);

    if (bytes.length <= IV_LENGTH) {
        throw new Error('Payload demasiado corto para contener IV + datos cifrados');
    }

    const iv = bytes.slice(0, IV_LENGTH);
    const cipherBytes = bytes.slice(IV_LENGTH);

    const key = await importAesKey(keyString);

    try {
        const plainBuffer = await crypto.subtle.decrypt(
            { name: 'AES-GCM', iv: iv },
            key,
            cipherBytes
        );
        return arrayBufferToString(plainBuffer);
    } catch (err) {
        throw new Error('Error al desencriptar (integridad fallida o clave incorrecta)');
    }
}

export async function decryptJsonValuesRecursive(value, keyString) {
    if (value === null || value === undefined) return value;

    if (Array.isArray(value)) {
        const out = [];
        for (let i = 0; i < value.length; i++) {
            out.push(await decryptJsonValuesRecursive(value[i], keyString));
        }
        return out;
    }

    if (typeof value === 'object') {
        const out = {};
        const keys = Object.keys(value);
        for (let k = 0; k < keys.length; k++) {
            const key = keys[k];
            out[key] = await decryptJsonValuesRecursive(value[key], keyString);
        }
        return out;
    }

    if (typeof value === 'string') {
        try {
            const plain = await decryptAesGcmBase64(value, keyString);
            if (!plain.startsWith("0")) {
                const num = Number(plain);
                if (!isNaN(num) && plain.trim() !== '') {
                    return num;
                }
            }
            return plain;
        } catch (e) {
            const num = Number(value);
            if (!isNaN(num) && value.trim() !== '') {
                return num;
            }
            return value;
        }
    }

    return value;
}
